var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGiftCardsinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "m8.095 14.997 1.608-4.232a4 4 0 0 1 5.04-2.568l23.352 6.8M55.03 22l3.5 1.137a4 4 0 0 1 2.567 5.04L55 46.943"
}), /*#__PURE__*/React.createElement("rect", {
  width: 52,
  height: 38,
  x: 3,
  y: 15,
  strokeLinecap: "square",
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "m18 39 6-6M30 39l-6-6M24 25.999 14 23v12l10-2.999zM24 25.999 34 23v12l-10-2.999zM3.25 29h10M24 16v37M35 29h19"
}))));
export default SvgGiftCardsinline;